window.cscoDarkMode = window.cscoDarkMode || {};

(function () {
  const storageKey = '_color_schema';
  const root = document.documentElement;

  function getStoredScheme() {
    try {
      const storedScheme = localStorage.getItem(storageKey);
      return storedScheme === 'dark' || storedScheme === 'light' ? storedScheme : null;
    } catch (error) {
      return null;
    }
  }

  function getPreferredScheme() {
    return getStoredScheme() || 'dark';
  }

  function updateButtons() {
    const isDark = root.getAttribute('data-scheme') === 'dark';

    document.querySelectorAll('.header__toggle-scheme').forEach((button) => {
      button.setAttribute('aria-pressed', isDark ? 'true' : 'false');
      button.setAttribute('aria-label', isDark ? 'Light Mode' : 'Dark Mode');
      button.title = isDark ? 'Light Mode' : 'Dark Mode';
    });
  }

  window.cscoDarkMode = {
    init() {
      this.changeScheme(getPreferredScheme(), false);
      updateButtons();

      document.querySelectorAll('.header__toggle-scheme').forEach((button) => {
        if (button.dataset.schemeToggleReady === 'true') return;

        button.dataset.schemeToggleReady = 'true';
        button.addEventListener('click', (event) => {
          event.preventDefault();
          const currentScheme = root.getAttribute('data-scheme') === 'dark' ? 'dark' : 'light';
          this.changeScheme(currentScheme === 'dark' ? 'light' : 'dark', true);
        });
      });
    },

    changeScheme(siteScheme, persist) {
      root.classList.add('scheme-toggled');
      root.setAttribute('data-scheme', siteScheme);

      if (persist) {
        try {
          localStorage.setItem(storageKey, siteScheme);
        } catch (error) {
          // The visible scheme can still change when browser storage is unavailable.
        }
      }

      updateButtons();

      window.setTimeout(() => {
        root.classList.remove('scheme-toggled');
      }, 120);
    },
  };

  document.addEventListener('DOMContentLoaded', () => window.cscoDarkMode.init());
  document.addEventListener('shopify:section:load', () => window.cscoDarkMode.init());
})();
